// extracted by mini-css-extract-plugin
export default {"rangeBox":"range_rangeBox__vTlem","number":"range_number__k5wNi"};